module.exports = __webpack_public_path__ + "img/bgcimg1.3d46e173.png";